module.exports = __webpack_public_path__ + "media/sand-bucket.83e842cf.svg";